import React, { Component } from "react";
import PropTypes from "prop-types";
import * as R from "ramda";
// import floodFill from "../lib/floodFill";
import CanvasHistory from "../lib/history";

function offset(el) {
  var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}

function convasToImage(canvas) {
  const dataUrl = canvas.toDataURL();
  const img = new Image();
  img.src = dataUrl;
  return img;
}

function cropPlusExport(img, cropX, cropY, cropWidth, cropHeight) {
  // create a temporary canvas sized to the cropped size
  var canvas = document.createElement("canvas");
  var ctx = canvas.getContext("2d");
  canvas.width = cropWidth;
  canvas.height = cropHeight;
  // use the extended from of drawImage to draw the
  // cropped area to the temp canvas
  ctx.drawImage(
    img,
    cropX,
    cropY,
    cropWidth,
    cropHeight,
    0,
    0,
    cropWidth,
    cropHeight
  );
  return canvas.toDataURL();
}

const slicePositionMap = {
  top: { x: 10, y: 0, width: 355, height: 10 },
  topRight: { x: 365, y: 0, width: 10, height: 10 },
  right: { x: 365, y: 10, width: 10, height: 355 },
  bottomRight: { x: 365, y: 365, width: 10, height: 10 },
  bottom: { x: 10, y: 365, width: 355, height: 10 },
  bottomLeft: { x: 0, y: 365, width: 10, height: 10 },
  left: { x: 0, y: 10, width: 10, height: 355 },
  topLeft: { x: 0, y: 0, width: 10, height: 10 },
};

const getBrushCursor = R.memoizeWith(
  JSON.stringify,
  ({ lineWidth, brushCol }, canvasEl) => {
    const radius = Math.ceil(lineWidth / 2);
    canvasEl.width = radius * 2;
    canvasEl.height = radius * 2;
    const ctx = canvasEl.getContext("2d");
    // ctx.strokeWidth = 1;
    ctx.strokeStyle = brushCol;
    ctx.fillStyle = brushCol;
    ctx.clearRect(0, 0, canvasEl.width, canvasEl.height);
    ctx.beginPath();
    ctx.arc(radius, radius, radius, 0, 2 * Math.PI);
    ctx.fill();
    const dataUrl = canvasEl.toDataURL("image/png", 0.5);
    return `url(${dataUrl}) ${radius} ${radius}, auto`;
  }
);

const slicePropType = PropTypes.shape({
  src: PropTypes.string,
});

class ReactPaint extends Component {
  static propTypes = {
    scale: PropTypes.number.isRequired,
    translation: PropTypes.shape({
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired,
    }).isRequired,
    className: PropTypes.string,
    style: PropTypes.object.isRequired,
    height: PropTypes.number,
    width: PropTypes.number,
    brushCol: PropTypes.string,
    lineWidth: PropTypes.number,
    onDraw: PropTypes.func,
    slices: PropTypes.shape({
      topLeft: slicePropType,
      top: slicePropType,
      topRight: slicePropType,
      right: slicePropType,
      bottomRight: slicePropType,
      bottom: slicePropType,
      bottomLeft: slicePropType,
      left: slicePropType,
    }),
  };
  static defaultProps = {
    className: "react-paint",
    style: {},
    height: 500,
    width: 500,
    brushCol: "#000",
    lineWidth: 8,
    scale: 1,
    translation: { x: 0, y: 0 },
    onDraw: () => {},
  };

  canvasRef = React.createRef();
  brushCanvasRef = React.createRef();

  state = {
    mouseDown: false,
    tool: "bucket",
  };

  componentDidMount() {
    const { brushCol, lineWidth, tileId } = this.props;
    const canvasEl = this.canvasRef.current;

    this.onResize();
    window.addEventListener("resize", this.onResize);

    this.ctx = canvasEl.getContext("2d");
    this.ctx.lineWidth = lineWidth;
    this.ctx.strokeStyle = brushCol;
    this.ctx.fillStyle = brushCol;
    this.ctx.lineJoin = this.ctx.lineCap = "round";
    this.subscribeToMouseMove();
    const persisted = this.readPersistedHistoryFromLocalStorage(tileId);
    this.history = new CanvasHistory(
      canvasEl,
      {
        onChange: (dataUrl) => {
          console.log("change");
          this.props.onDraw(dataUrl);
        },
        onDraw: (src, cb, initial = false) => {
          if (src) {
            console.log("draw");
            const canvasPic = new Image();
            canvasPic.src = src;
            canvasPic.onload = async () => {
              this.ctx.clearRect(0, 0, canvasEl.width, canvasEl.height);
              this.ctx.drawImage(canvasPic, initial ? 0 : 0, initial ? 0 : 0);
              this.drawSlices();
              cb && cb();
              this.persistHistoryToLocalStorage(
                await this.history.getSnapshot(),
                tileId
              );
            };
          } else {
            this.ctx.clearRect(0, 0, canvasEl.width, canvasEl.height);
          }
        },
      },
      persisted
    );
    this.props.onAPIReady({
      history: this.history,
      clear: () => {
        this.ctx.clearRect(0, 0, canvasEl.width, canvasEl.height);
        this.history.push();
      },
      getSnapshot: async () => {
        return new Promise((res, rej) => {
          const img = convasToImage(canvasEl);
          img.onload = () => {
            const snapshot = cropPlusExport(img, 10, 10, 355, 355);
            res(snapshot);
          };
        });
      },
    });
  }

  componentWillUpdate(nextProps) {
    const { brushCol, lineWidth } = this.props;
    if (brushCol !== nextProps.brushCol || lineWidth !== nextProps.lineWidth) {
      this.ctx.lineWidth = nextProps.lineWidth;
      this.ctx.strokeStyle = nextProps.brushCol;
      this.ctx.fillStyle = nextProps.brushCol;
    }
  }

  componentWillUnmount = () => {
    this.unsubscribeFromMouseMove();
    window.removeEventListener("resize", this.onResize);
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.brushCol !== this.props.brushCol) {
      this.ctx.beginPath();
      this.ctx.strokeStyle = nextProps.brushCol;
      this.ctx.fillStyle = nextProps.brushCol;
    }
    if (nextProps.src !== this.props.src) {
      this.history.clear();
      const canvasEl = this.canvasRef.current;
      const canvasPic = new Image();
      canvasPic.src = nextProps.src;
      canvasPic.onload = async () => {
        console.log("UNSAFE_componentWillReceiveProps");
        this.ctx.clearRect(0, 0, canvasEl.width, canvasEl.height);
        this.ctx.drawImage(canvasPic, 10, 10);
        this.drawSlices();
        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
        const snapshot = await this.history.getSnapshot();
        this.persistHistoryToLocalStorage(snapshot);
        this.history.push();
      };
    } else if (nextProps.slices !== this.props.slices) {
      this.drawSlices();
    }
  }

  subscribeToMouseMove = () => {
    const document = window.document.documentElement;
    document.addEventListener(
      "mousemove",
      (e) => {
        this.mouseMove(e);
      },
      {
        passive: true,
      }
    );
    document.addEventListener("touchmove", this.mouseMove, {
      passive: false,
    });
    this.unsubscribeFromMouseMove = () => {
      document.removeEventListener("mousemove", this.onmouseMove);
      document.removeEventListener("touchmove", this.onmouseMove);
    };
  };

  readPersistedHistoryFromLocalStorage = (tileId = "") => {
    const defaultData = { stack: [], step: -1 };
    const str = localStorage.getItem("paint-stack");
    try {
      const data = JSON.parse(str);
      if (!data) {
        return { stack: [], step: -1 };
      }
      if (data[tileId]) {
        return data[tileId];
      }
      this.persistHistoryToLocalStorage(defaultData, tileId);
      return defaultData;
    } catch (error) {
      return defaultData;
    }
  };

  persistHistoryToLocalStorage = ({ stack, step }, tileId = "") => {
    const str = JSON.stringify({ [tileId]: { stack, step } });
    localStorage.setItem("paint-stack", str);
  };

  drawPoint = (x, y) => {
    this.ctx.scale(this.props.scale, this.props.scale);
    this.ctx.beginPath();
    this.ctx.arc(x, y, this.props.lineWidth / 2, 0, 2 * Math.PI);
    this.ctx.fill();
    this.ctx.closePath();
    this.ctx.setTransform(1, 0, 0, 1, 0, 0);
  };

  drawSlices = () => {
    if (this.props.slices) {
      this.ctx.scale(this.props.scale, this.props.scale);
      Object.entries(this.props.slices).forEach(([kind, { src }]) => {
        const img = new Image();
        img.src = src;
        img.onload = () => {
          const position = slicePositionMap[kind];
          if (position) {
            const { x, y, width, height } = position;
            this.ctx.drawImage(img, x, y, width, height);
          }
        };
      });
    }
  };

  getXFromEvent = (e) =>
    R.pipe(
      (e) => e.pageX || R.pathOr(0, ["touches", 0, "pageX"], e),
      (num) => num - this.state.offsetX || 0
    )(e);

  getYFromEvent = (e) =>
    R.pipe(
      (e) => e.pageY || R.pathOr(0, ["touches", 0, "pageY"], e),
      (num) => num - this.state.offsetY || 0
    )(e);

  getIsMouseOutside = (x, y) =>
    x < 0 || y < 0 || x >= this.props.width || y >= this.props.height;

  onResize = () => {
    const canvasEl = this.canvasRef.current;
    const canvasOffset = offset(canvasEl);
    const offsetX = canvasOffset.left;
    const offsetY = canvasOffset.top;
    this.setState({ offsetY, offsetX });
  };

  mouseDown = (e) => {
    const stateChanges = {
      isMouseMoving: false,
    };
    const x = this.getXFromEvent(e) - this.props.translation.x;
    const y = this.getYFromEvent(e) - this.props.translation.y;
    stateChanges.x = x;
    stateChanges.y = y;
    const isMouseOutside = this.getIsMouseOutside(x, y);
    if (!this.state.mouseDown) {
      stateChanges.mouseDown = true;
    }
    if (!isMouseOutside) {
      this.ctx.scale(this.props.scale, this.props.scale);
      this.ctx.moveTo(x, y);
      this.ctx.beginPath();
      this.ctx.setTransform(1, 0, 0, 1, 0, 0);
    }
    this.setState(stateChanges);
  };

  mouseUp = (e) => {
    const stateChanges = { mouseDown: false, isMouseMoving: false };
    // TODO: add some luft
    if (this.state.mouseDown && !this.state.isMouseMoving) {
      const x = this.getXFromEvent(e) - this.props.translation.x;
      const y = this.getYFromEvent(e) - this.props.translation.y;
      stateChanges.x = x;
      stateChanges.y = y;
      this.drawPoint(x, y);

      this.history.push();
    }
    if (this.state.mouseDown && this.state.isMouseMoving) {
      this.history.push();
    }
    this.setState(stateChanges);
    if (e.touches) {
      e.stopPropagation();
    }
  };

  mouseMove = (e) => {
    if (e.touches && e.touches.length > 1) {
      return;
    }
    const x = this.getXFromEvent(e) - this.props.translation.x;
    const y = this.getYFromEvent(e) - this.props.translation.y;
    const isMouseOutside = this.getIsMouseOutside(x, y);
    const stateChanges = {
      isMouseOutside,
    };
    stateChanges.x = x;
    stateChanges.y = y;

    if (this.state.isMouseOutside && !isMouseOutside) {
      this.ctx.scale(this.props.scale, this.props.scale);
      this.ctx.closePath();
      this.ctx.moveTo(x, y);
      this.ctx.beginPath();
      this.ctx.setTransform(1, 0, 0, 1, 0, 0);
    }
    if (this.state.mouseDown) {
      stateChanges.isMouseMoving = true;
      // prevent IOS scroll when drawing
      if (e.touches) {
        e.preventDefault();
      }
      if (!isMouseOutside) {
        this.ctx.scale(this.props.scale, this.props.scale);
        this.ctx.lineTo(x, y);
        this.ctx.stroke();
        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
      }
    }
    this.setState(stateChanges);
  };

  render() {
    const { width, height, style, className, lineWidth, brushCol } = this.props;
    const cursor = this.brushCanvasRef.current
      ? getBrushCursor({ lineWidth, brushCol }, this.brushCanvasRef.current)
      : "unset";
    return (
      <div className={className}>
        <canvas
          ref={this.brushCanvasRef}
          style={{
            position: "absolute",
            display: "none",
          }}
        />
        <canvas
          ref={this.canvasRef}
          className={`${className}__canvas`}
          width={width}
          height={height}
          style={{
            ...style,
            transform: `translate(${this.props.translation.x}px, ${this.props.translation.y}px)`,
            cursor,
            width: this.props.width * this.props.scale,
            height: this.props.height * this.props.scale,
          }}
          onMouseDown={this.mouseDown}
          onTouchStart={this.mouseDown}
          onMouseUp={this.mouseUp}
          onTouchEnd={this.mouseUp}
          //   onMouseMove={this.mouseMove}
          //   onTouchMove={this.mouseMove}
        />
      </div>
    );
  }
}

export { ReactPaint };
